import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import Axios from "axios";
import "./POcreation.css";
import swal from "sweetalert";
import Table from "react-bootstrap/esm/Table";
import Magnifier from "react-magnifier";

function POcreation() {
  const [list, setlist] = useState([]);
  const [list1, setlist1] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [PO, setPO] = useState([]);
  const [skuCounts, setSkuCounts] = useState({});
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getlist`).then((response) => {
      const allData = response.data;
      const activeData = allData.filter((form) => form.AuthStatus === "active");

      setFilteredData(activeData);

      setlist(activeData);
    });
  }, []);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getOrder`).then((response) => {
      setlist1(response.data);
    });
  }, []);

  const handleInputChange = (sku, column, value, row) => {
    const index = list.findIndex((rowData) => rowData.sku === sku);
    const newTableData = [...list];
    newTableData[index][column] = value;

    if (!selectedCheckboxes.includes(sku)) {
      swal("Please select the checkbox first", "", "warning");
      return;
    }

    if (column === "quantity") {
      const quantity = parseInt(value);
      const purchasePrice = parseFloat(newTableData[index].purchasePrice);
      newTableData[index].total = quantity * purchasePrice;
    }


    const abc = `${row.sku.substring(0, 5)}-${skuCounts[row.sku] + 1 || 1}`;
    newTableData[index].batchid = abc;

    setlist(newTableData);
  };

  const handleFilter = () => {
    if (filterText.trim() === "") {
      setFilteredData(list);
    } else {
      const filteredList = list.filter(
        (form) =>
          form.sku.toLowerCase().includes(filterText.toLowerCase()) ||
          form.title.toLowerCase().includes(filterText.toLowerCase())
      );
      setFilteredData(filteredList);
    }
  };

  const handleCheckboxChange = (event) => {
    const { value } = event.target;
    const selectedlist = list.find((listdata) => listdata.sku === value);

    if (event.target.checked) {
      setSelectedCheckboxes([...selectedCheckboxes, value]);
      setPO([...PO, selectedlist]);
    } else {
      setSelectedCheckboxes(
        selectedCheckboxes.filter((checkbox) => checkbox !== value)
      );
      setPO(PO.filter((listdata) => listdata.sku !== selectedlist.sku));
    }
  };

  function handleSubmit() {
    if (selectedCheckboxes.length === 0) {
      alert("Please select the checkbox and fill it's Details");
      return;
    }

    const missingDetailsItems = PO.filter(
      (item) => !item.purchasePrice || !item.quantity
    );

    if (missingDetailsItems.length > 0) {

      swal({
        title: "Please fill input field",
        text: "",
        icon: "error",
      });
      return;
    }

    Axios.post(`${INVENTORY_API_BASE_URL}/POgivenn`, PO)
      .then((result) => {
      })
      .catch((error) => {
        alert("service error");
      });
    swal({
      title: "Purchase Order Created",
      text: "",
      icon: "success",
    }).then(() => {
      window.location.reload();
    });
  }

  function handleRowClick() {
    const skuCountMap = {};
    list1.forEach((item) => {
      item.list.forEach((subItem) => {
        const sku = subItem.sku;
        if (skuCountMap[sku]) {
          skuCountMap[sku] += 1;
        } else {
          skuCountMap[sku] = 1;
        }
      });
    });
    setSkuCounts(skuCountMap);
  }

  return (
    <div className="POcreation">
      <main className="po-workspace">
        <header className="po-page-header">
          <div className="po-page-heading">
            <span className="po-eyebrow">Purchase order workspace</span>
            <h1>Create purchase order</h1>
            <p>
              Build an order from your active catalog, enter pricing and quantities,
              then save it for processing.
            </p>
          </div>
          <div className="po-live-indicator">
            <span aria-hidden="true" />
            Active product catalog
          </div>
        </header>

        <section className="po-overview" aria-label="Purchase order overview">
          <article className="po-overview-card">
            <span className="po-overview-marker" aria-hidden="true">01</span>
            <div className="po-overview-copy">
              <span className="po-overview-label">Active products</span>
              <strong>{list.length}</strong>
              <small>Available in the catalog</small>
            </div>
          </article>
          <article className="po-overview-card">
            <span className="po-overview-marker" aria-hidden="true">02</span>
            <div className="po-overview-copy">
              <span className="po-overview-label">Matching products</span>
              <strong>{filteredData.length}</strong>
              <small>Currently shown below</small>
            </div>
          </article>
          <article className="po-overview-card">
            <span className="po-overview-marker" aria-hidden="true">03</span>
            <div className="po-overview-copy">
              <span className="po-overview-label">Selected items</span>
              <strong>{PO.length}</strong>
              <small>Included in this purchase order</small>
            </div>
          </article>
        </section>

        <section className="po-control-card" aria-label="Purchase order controls">
          <div className="po-search-group">
            <div className="po-search-input-wrap">
              <span className="po-search-glyph" aria-hidden="true">⌕</span>
              <input
                className="po-search-input"
                type="text"
                placeholder="Search by SKU or product title"
                aria-label="Search by SKU or product title"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </div>
            <button
              className="po-button po-button--filter"
              type="button"
              onClick={handleFilter}
            >
              Apply filter
              <span aria-hidden="true">→</span>
            </button>
          </div>

          <div className="po-control-divider" aria-hidden="true" />

          <div className="po-selected-summary">
            <div className="po-selected-count">
              <span className="po-selected-mark">{PO.length}</span>
              <div className="po-selected-copy">
                <strong>Items selected</strong>
                <small>
                  {PO.length > 0
                    ? "Add pricing and quantity before saving"
                    : "Choose products from the catalog below"}
                </small>
              </div>
            </div>
            <button
              className="po-button po-button--save"
              type="button"
              onClick={handleSubmit}
            >
              Save order
              <span aria-hidden="true">↗</span>
            </button>
          </div>
        </section>

        {PO.length > 0 && (
          <section className="po-selection-card" aria-label="Selected products">
            <div className="po-selection-heading">
              <h2>Selected for this order</h2>
              <span>{PO.length} {PO.length === 1 ? "ITEM" : "ITEMS"}</span>
            </div>
            <div className="po-selection-list">
              {PO.map((item) => (
                <span className="po-selection-chip" key={item.sku}>
                  <strong>{item.sku}</strong>
                  <span>Qty: {item.quantity || 0}</span>
                </span>
              ))}
            </div>
          </section>
        )}

        <section className="po-catalog-card" aria-label="Active product catalog">
          <div className="po-catalog-heading">
            <div>
              <span className="po-section-eyebrow">Inventory</span>
              <h2>Active product catalog</h2>
              <p>Enter the purchase price and order quantity for each selected product.</p>
            </div>
            <span className="po-result-count">
              {filteredData.length} {filteredData.length === 1 ? "PRODUCT" : "PRODUCTS"}
            </span>
          </div>

          <div className="po-table-scroll">
            <Table className="createtable">
              <thead>
                <tr>
                  <th scope="col" className="po-select-column">Select</th>
                  <th scope="col">SKU</th>
                  <th scope="col">Image</th>
                  <th scope="col" className="po-title-column">Product title</th>
                  <th scope="col">Printing price</th>
                  <th scope="col">Order quantity</th>
                  <th scope="col">Medium</th>
                  <th scope="col">Edition</th>
                  <th scope="col">MRP</th>
                  <th scope="col">Order value</th>
                  <th scope="col">Batch ID</th>
                </tr>
              </thead>
              <tbody className="pirfon">
                {filteredData.length > 0 ? (
                  filteredData.map((row) => (
                    <tr
                      key={row.sku}
                      className={selectedCheckboxes.includes(row.sku) ? "po-row-selected" : ""}
                      onClick={handleRowClick}
                    >
                      <td data-label="Select">
                        <input
                          className="po-checkbox"
                          type="checkbox"
                          name="listdata"
                          value={row.sku}
                          aria-label={`Select ${row.sku}`}
                          onChange={handleCheckboxChange}
                          checked={selectedCheckboxes.includes(row.sku)}
                        />
                      </td>
                      <td data-label="SKU"><span className="po-sku">{row.sku}</span></td>
                      <td data-label="Image">
                        <div className="po-product-image">
                          <Magnifier
                            src={`https://d10idqgatxnd06.cloudfront.net/${row.img}`}
                            width={48}
                            height={48}
                            mgShape="square"
                            mgWidth={650}
                            mgHeight={650}
                            mgMouseOffsetX={234}
                            mgMouseOffsetY={234}
                            mgShowOverflow
                          />
                        </div>
                      </td>
                      <td className="po-title-column" data-label="Product title">
                        <span className="po-product-title">{row.title}</span>
                      </td>
                      <td data-label="Printing price">
                        <input
                          className="po-number-input"
                          type="number"
                          aria-label={`Printing price for ${row.sku}`}
                          value={row.purchasePrice}
                          onChange={(e) =>
                            handleInputChange(
                              row.sku,
                              "purchasePrice",
                              e.target.value,
                              row
                            )
                          }
                          onWheel={(e) => e.target.blur()}
                        />
                      </td>
                      <td data-label="Order quantity">
                        <input
                          className="po-number-input"
                          type="number"
                          aria-label={`Order quantity for ${row.sku}`}
                          value={row.quantity}
                          onChange={(e) =>
                            handleInputChange(
                              row.sku,
                              "quantity",
                              e.target.value,
                              row
                            )
                          }
                          onWheel={(e) => e.target.blur()}
                        />
                      </td>
                      <td data-label="Medium">{row.Medium}</td>
                      <td data-label="Edition">{row.edition}</td>
                      <td data-label="MRP">{row.mrp}</td>
                      <td data-label="Order value">
                        <span className="po-row-total">
                          {row.total !== undefined
                            ? row.total.toFixed(2)
                            : (row.quantity * row.purchasePrice).toFixed(2)}
                        </span>
                      </td>
                      <td data-label="Batch ID">
                        <span className="po-batch-id">
                          {row.sku.substring(0, 5)}-{skuCounts[row.sku] || 0}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="po-empty-cell" colSpan={11}>
                      <div className="po-no-results">
                        <strong>No products found</strong>
                        <span>Try another SKU or product title.</span>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </section>
      </main>
    </div>
  );
}

export default POcreation;
